import { enable, disable } from './cookies'

const ElectronCookies = {
  enable,
  disable
}

;(() => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ;(globalThis as any).ElectronCookies = ElectronCookies
})()

export { enable, disable }
